<template>
	<table class="table">
		<thead>
			<tr>
				<th colspan="2">Conguagli attesi</th>
			</tr>
		</thead>
		<tbody>
			<tr>
				<th>Fattura</th>
				<td>{{ invoice.value }}</td>
			</tr>
			<tr>
				<th>Nota Credito</th>
				<td>{{ credit.value }}</td>
			</tr>
		</tbody>
	</table>
</template>
<script>
import utils from '../../../utilsMixin';
export default {
	name: "ConguaglioTable",
	mixins: [utils],
	props: ['calculatedTotal', 'invoiceTotal'],
	computed: {
		diff() {
			return this.calculatedTotal - this.invoiceTotal
		},
		invoice() {
			if(this.diff > 0) {
				return {
					value: `€ ${this.formatPrecision(this.diff, 0)}`,
					raw: this.diff
				}
			}
			return {
				value: '',
				raw: ''
			}
		},
		credit() {
			if (this.diff < 0) {
				return {
					value: `€ ${this.formatPrecision(this.diff * -1, 0)}`,
					raw: this.diff * -1
				}
			}
			return {
				value: '',
				raw: ''
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/BillAudit/Tables/ConguaglioTable.vue